import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
} from "react-router-dom";

import Home from "./components/Home";
import Rsvp from "./components/Rsvp";
import Registry from "./components/RegistryPage";
import Timeline from "./components/Timeline";
import AdminPortal from "./components/AdminPortal";
import AdminLogin from "./components/LogIn";
import Engagement from "./components/engagement";
import Faqs from "./components/Faqs";
import "./App.css";

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  return (
    <Router>
      <div className="App">
        <NavigationBar />
        <main>
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/rsvp" element={<Rsvp />} /> 
            <Route path="/registry" element={<Registry />}/>
            <Route path="/faqs" element={<Faqs /> }/>
            <Route path="/gallery" element={<Engagement /> }/>
        
            <Route
              path="/admin"
              element={
                authenticated ? (
                  <AdminPortal />
                ) : (
                  <AdminLogin setAuthenticated={setAuthenticated} />
                )
              }
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

function NavigationBar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);


  return (
    <header className="nav-header">
      <nav className="navbar">
        {/* Hamburger menu - far left on mobile */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ") setMenuOpen(!menuOpen);
          }}
        >
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
         
        </div>

        {/* Nav Links */}
        <ul className={`nav-links ${menuOpen ? "show" : ""}`}>
          <li>
            <Link to="/home" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
          <Link to="/rsvp" onClick={() => setMenuOpen(false)}>
              RSVP
            </Link>
          </li>
          <li>
            <Link to="/timeline" onClick={() => setMenuOpen(false)}>
              Wedding Timeline
            </Link>
          </li>
          <li>
            <Link to="/registry" onClick={() => setMenuOpen(false)}>
              Registry
            </Link>
          </li>
          <li>
            <Link to="/faqs" onClick={() => setMenuOpen(false)}>
              FAQs
            </Link>
          </li>
          <li>
            <Link to="/gallery" onClick={() => setMenuOpen(false)}>
              Gallery
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default App;
